export class AppProfileToken {
  static IAppProfileRepository = Symbol("IAppProfileRepository");
  static AppProfileUseCase = Symbol("AppProfileUseCase");
  static AppProfileViewModel = Symbol("AppProfileViewModel");
}
